import { render } from "./LbrxRoomStatus.vue?vue&type=template&id=2ab2395d&scoped=true"
import script from "./LbrxRoomStatus.vue?vue&type=script&lang=js"
export * from "./LbrxRoomStatus.vue?vue&type=script&lang=js"

import "./LbrxRoomStatus.vue?vue&type=style&index=0&id=2ab2395d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab2395d"]])

export default __exports__